<template>
  <div>
    <div class="overline">Current {{ itemsName }}</div>
    <ul>
      <li v-for="(item, i) in currentItems" :key="'old_' + i">
        {{ item[labelKey] }}
        <v-btn
          x-small
          text
          color="primary"
          class="caption"
          @click="goToEdit(item)"
          >edit</v-btn
        >
        <!-- <v-btn icon x-small><v-icon color="red" x-small>mdi-minus-circle</v-icon></v-btn> -->
      </li>
    </ul>
    <div v-if="newItems && newItems.length">
      <div class="overline">New {{ itemsName }}</div>
      <ul>
        <li v-for="(item, i) in newItems" :key="'new_' + i">
          {{ item[labelKey] }}
          <v-btn icon small @click="removeNewItem(i)"
            ><v-icon small color="red">mdi-minus-circle</v-icon></v-btn
          >
          <!-- <v-btn icon x-small><v-icon color="red" x-small>mdi-minus-circle</v-icon></v-btn> -->
        </li>
      </ul>
    </div>
    <v-slide-y-transition>
      <v-btn
        text
        color="primary"
        v-if="!addLensForm"
        @click="addLensForm = true"
        ><v-icon small color="green">mdi-plus-circle</v-icon>Quick Add</v-btn
      >
      <v-card v-if="addLensForm" color="#fff9ec">
        <v-card-title class="title">Quick Add</v-card-title>

        <v-card-text>
          <div v-for="(type, field) in fields" :key="field">
            <v-text-field
              outlined
              v-if="type == 'text'"
              :label="field"
              v-model="inputs[field]"
            ></v-text-field>
          </div>
          <div class="caption" v-if="note">
            {{ note }}
          </div></v-card-text
        >
        <v-card-actions class="d-flex flex-row">
          <v-spacer></v-spacer>
          <v-btn text small color="" @click="addLensForm = false">Cancel</v-btn>
          <v-btn text small color="primary" @click="addItem()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-slide-y-transition>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "QuickAddRgp",
  props: {
    currentItems: null,
    idKey: { type: String, default: "id" },
    labelKey: { type: String, default: "name" },
    itemsName: { type: String, default: "Lenses" },
    note: {
      type: String,
      default:
        'Items will only be added when this page is saved. They will NOT be displayed by default (you will need to check the "display" checkbox on the item)',
    },
    fields: {
      type: Object,
      default() {
        // should include a key that matches labelKey (i.e. "name")
        return { name: "text", url: "text" };
      },
    },
  },
  data: function () {
    return {
      addLensForm: false,
      newItems: [],
      deleteItems: [],
      inputs: {},
    };
  },
  methods: {
    addItem() {
      let newObj = JSON.parse(JSON.stringify(this.inputs));
      this.newItems.push(newObj);
      this.$emit("newItems", this.newItems);
      this.resetInputs();
      this.addLensForm = false;
    },
    resetInputs() {
      let fields = Object.keys(this.inputs);
      let i = this.inputs;
      fields.forEach((f) => {
        i[f] = null;
      });
    },
    removeNewItem(index) {
      this.newItems.splice(index, 1);
    },

    goToEdit(item) {
      let ok = confirm(
        "You are leaving this page to edit " +
          item[this.labelKey] +
          ". Any changes you made to this company will be lost. Click OK to continue. "
      );
      // todo - make this feature more customizable (use a prop for path & item identifier) if reusing this component
      if (ok) this.$router.push({ path: "/boss/rgp-lenses/" + item.slug });
    },
  },
  computed: {},
  mounted() {
    let fields = Object.keys(this.fields);
    fields.forEach((f) => {
      this.inputs[f] = null;
    });
  },
};
</script>

<style scoped></style>
